import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../components/Layout";
import MetaTags from "../lib/MetaTags";
import Breadcrumbs from "../components/Breadcrumbs";
import { ArticleCard } from "../components/ArticleCard";
import { fetchArticles } from "../lib/api";

export default function Tag() {
  const { slug } = useParams();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchArticles({ tag: slug, limit: 40 })
      .then((d) => setItems(d.items || []))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <Layout>
      <MetaTags title={`#${slug}`} description={`Articles tagged ${slug}`} />
      <section className="border-b border-[#121212] bg-white">
        <div className="ceg-container py-10">
          <Breadcrumbs items={[{ to: "/", label: "Home" }, { label: `#${slug}` }]} />
          <p className="ceg-overline mt-6">Tag</p>
          <h1 className="font-['Outfit'] font-black tracking-tighter text-4xl sm:text-5xl md:text-6xl lg:text-7xl mt-3 break-words">#{slug}</h1>
          <p className="mt-3 text-sm text-[#5C5C5C]">{items.length} {items.length === 1 ? "guide" : "guides"}</p>
        </div>
      </section>
      <section className="ceg-container py-12">
        {loading ? (
          <p className="text-sm text-[#5C5C5C]">Loading...</p>
        ) : items.length === 0 ? (
          <p className="text-sm text-[#5C5C5C]" data-testid="tag-empty">No articles with this tag.</p>
        ) : (
          <div className="grid grid-cols-12 gap-6">
            {items.map((a, i) => (
              <div key={a.slug} className="col-span-12 sm:col-span-6 lg:col-span-4">
                <ArticleCard article={a} index={i} />
              </div>
            ))}
          </div>
        )}
      </section>
    </Layout>
  );
}
